import React from "react";
import Accordion from "react-bootstrap/Accordion";
const Faq = () => {
  return (
    <div id="faq">
      <div className="faq pt-5 pb-5 " style={{ overflow: "hidden" }}>
        <div className="container">
          <div className="pb-5">
            <div className="d-flex align-items-center justify-content-between">
              <div className="rotate-1">
                <img className="w-100" src="/assets/images/1.svg" alt="" />
              </div>
              <div className="rotate-2">
                <img className="w-100" src="/assets/images/2.svg" alt="" />
              </div>
              <div className="rotate-3">
                <img className="w-100" src="/assets/images/3.svg" alt="" />
              </div>
              <div className="rotate-4">
                <img className="w-100" src="/assets/images/4.svg" alt="" />
              </div>
              <div className="rotate-5">
                <img className="w-100" src="/assets/images/5.svg" alt="" />
              </div>
              <div className="rotate-6">
                <img className="w-100" src="/assets/images/6.svg" alt="" />
              </div>
            </div>
          </div>

          <div className="inner-faq">
            <h2 className="pb-3" data-aos="zoom-in" data-aos-duration="1000">
              Frequently Asked Questions
            </h2>
            <p data-aos="zoom-in" data-aos-duration="2900" className="pb-5">
              Gain invaluable predictive analytics and actionable insights,
              empowering your team to make data-driven decisions and close deal.
            </p>
            <Accordion>
              <Accordion.Item
                eventKey="0"
                data-aos="fade-up"
                data-aos-duration="1100"
              >
                <Accordion.Header>What is Pharma Trades?</Accordion.Header>
                <Accordion.Body>
                  Pharma Trades is a platform that facilitates secure and
                  efficient OTC trading of cryptocurrencies and tokens on
                  Ethereum and Solana blockchains, utilizing the native $PHARMA
                  token.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item
                eventKey="1"
                data-aos="fade-up"
                data-aos-duration="1100"
              >
                <Accordion.Header>
                  How does Pharma Trades ensure security?
                </Accordion.Header>
                <Accordion.Body>
                  We utilize audited smart contracts, safe transfer methods, and
                  reentrancy guards to protect user assets and data.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item
                eventKey="2"
                data-aos="fade-up"
                data-aos-duration="1100"
              >
                <Accordion.Header>
                  Do I need technical knowledge to use Pharma Trades?
                </Accordion.Header>
                <Accordion.Body>
                  No, the platform is designed to be user-friendly, with an
                  intuitive interface guiding you through each step.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item
                eventKey="3"
                data-aos="fade-up"
                data-aos-duration="1100"
              >
                <Accordion.Header>Are there any fees?</Accordion.Header>
                <Accordion.Body>
                  Yes, there is an initiation fee equal to 1% of the total trade
                  value, payable in $PHARMA tokens.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item
                eventKey="4"
                data-aos="fade-up"
                data-aos-duration="1100"
              >
                <Accordion.Header>
                  How do I acquire $PHARMA tokens?
                </Accordion.Header>
                <Accordion.Body>
                  $PHARMA tokens can be acquired through participating exchanges
                  or directly from the Pharma Trades platform, if available.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item
                eventKey="5"
                data-aos="fade-up"
                data-aos-duration="1100"
              >
                <Accordion.Header>What wallets are supported?</Accordion.Header>
                <Accordion.Body>
                  <ul>
                    <li>
                      <b> Ethereum:</b> MetaMask and any wallet compatible with
                      Web3.
                    </li>
                    <li>
                      <b> Solana:</b> Phantom and other Solana-compatible
                      wallets.
                    </li>
                  </ul>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item
                eventKey="6"
                data-aos="fade-up"
                data-aos-duration="1100"
              >
                <Accordion.Header>
                  Can I set up a deal with a vesting schedule?
                </Accordion.Header>
                <Accordion.Body>
                  Yes, sellers can define custom vesting schedules during deal
                  initiation.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item
                eventKey="7"
                data-aos="fade-up"
                data-aos-duration="1100"
              >
                <Accordion.Header>
                  How does the referral system work?
                </Accordion.Header>
                <Accordion.Body>
                  Include a referrer's address when initiating a deal. After the
                  deal completes, the referrer can claim their reward in $PHARMA
                  tokens.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item
                eventKey="8"
                data-aos="fade-up"
                data-aos-duration="1100"
              >
                <Accordion.Header>
                  Is the smart contract code available for review?
                </Accordion.Header>
                <Accordion.Body>
                  Yes, all our smart contracts are open-source and available on
                  our GitHub repository.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item
                eventKey="9"
                data-aos="fade-up"
                data-aos-duration="1100"
              >
                <Accordion.Header>
                  Can developers integrate Pharma Trades into their
                  applications?
                </Accordion.Header>
                <Accordion.Body>
                  Yes, we offer SDKs and APIs for developers to interact with
                  our platform.
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Faq;
